import React from 'react';
import {
  Input, Button, Row, Select, Col, Modal, Switch, message
} from 'antd';
import {Option} from "antd/lib/mentions";
import {doc, updateDoc} from "firebase/firestore";
import {firestore} from "../../services";

const Dialog = ({open, title, type, onAccept, onCancel, onChange, onDelete, model, extraData, saving}) => {

  const handleAccept = () => {
    onAccept();
  };

  const reconocimiento = async (value, row) => {
    let data = {
      reconocimiento: model.reconocimiento !== undefined ? (model.reconocimiento === value ? !value : value) : value,
    }

    const res = await updateDoc(doc(firestore, 'usuarios', row.id), data);
    !res ? message.success(data.reconocimiento === true ? 'Se asigno Reconocimiento.' : 'Se quito Reconocimiento.') : message.error('Error al actualizar.');
  }

  return (
    <Modal
      title={title}
      visible={open}
      footer={null}
      closeIcon={onCancel}
      width={1000}
    >

      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <label>Apellidos</label>
          <Input
            size="large"
            value={model.apellidos}
            onChange={event => onChange('apellidos', event.target.value)}
          />
        </Col>

        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <label>Nombre</label>
          <Input
            size="large"
            value={model.nombre}
            onChange={event => onChange('nombre', event.target.value)}
          />
        </Col>

        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <label>Correo</label>
          <Input
            size="large"
            value={model.correo}
            onChange={event => onChange('correo', event.target.value)}
          />

        </Col>
        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <label>Empresa</label>
          <Input
            size="large"
            value={model.empresa}
            onChange={event => onChange('empresa', event.target.value)}
          />
        </Col>
        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <label>Télefono</label>
          <Input
            size="large"
            value={model.telefono}
            onChange={event => onChange('telefono', event.target.value)}
          />
        </Col>
        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <label>Ciudad</label>
          <Input
            size="large"
            value={model.ciudad}
            onChange={event => onChange('ciudad', event.target.value)}
          />
        </Col>
        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <label>Pais</label>
          <Input
            size="large"
            value={model.pais}
            onChange={event => onChange('pais', event.target.value)}
          />
        </Col>
        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <label>Ocupación</label>
          <Input
            size="large"
            value={model.ocupacion}
            onChange={event => onChange('ocupacion', event.target.value)}
          />
        </Col>

        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <label>Rol</label>
          <Select
            value={model.rol}
            size="large"
            onChange={event => onChange('rol', event.value)}
            style={{width: "100%"}}
          >
            <Option value="usuario">Usuario</Option>
            <Option value="admin">Administrador</Option>
          </Select>
          {model.rol === 'admin' ?
            <label style={{color: "red"}}>Los roles Administradores pueden acceder a todo el contenido, pueden borrar
              videos, borrar usuarios etc.</label> : ""}
        </Col>

        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <label>Pagó</label>
          <Switch
            checkedChildren="Si"
            unCheckedChildren="No"
            checked={model.pago}
            size="default"
            onChange={(event) => onChange('pago', !model.pago)}
          />
        </Col>
      </Row>

      <Row
        style={{padding: '33px 0'}}
      >
        <Col
          className="gutter-row"
          xs={{span: 24, offset: 8}}
          sm={{span: 24, offset: 8}}
          md={{span: 8, offset: 8}}
          lg={{span: 8, offset: 8}}
          xxl={{span: 8, offset: 8}}
        >
          <Button
            type="danger"
            size="large"
            block
            onClick={() => {
              onCancel()
            }}
          >
            Cancelar
          </Button>
        </Col>
        <Col
          className="gutter-row"
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
        >
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            block
            onClick={handleAccept}
          >
            Guardar
          </Button>
        </Col>
      </Row>
    </Modal>
  )
}

export default Dialog
